import { BACKEND_URL_V1, deletee, get, post } from "lib/Api";
import { BusniessUnit } from "types/Branch";
import { FMSError } from "types/Error";
import { ICateringRecipe } from "types/CateringRecipe";

const BASE = `${BACKEND_URL_V1}/catering-recipes`;

export const listCateringRecipesByBusinessUnit = async (
  businessUnit: BusniessUnit
): Promise<ICateringRecipe[] | null> => {
  try {
    const response = await get<ICateringRecipe[]>(
      `${BASE}?businessUnit=${businessUnit}`
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const listCateringRecipesByBranch = async (
  branchId: string
): Promise<ICateringRecipe[] | null> => {
  try {
    const response = await get<ICateringRecipe[]>(
      `${BASE}/by-branch/${branchId}`
    );
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const getCateringRecipe = async (
  recipeId: string
): Promise<ICateringRecipe | null> => {
  try {
    const response = await get<ICateringRecipe>(`${BASE}/${recipeId}`);
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return null;
  } catch {
    return null;
  }
};

export const createCateringRecipe = async (
  recipe: ICateringRecipe
): Promise<ICateringRecipe | FMSError> => {
  try {
    const response = await post<ICateringRecipe>(BASE, recipe);
    if (Math.floor(response.status / 100) === 2 && response.parsedBody) {
      return response.parsedBody;
    }
    return new FMSError(
      response.serverError?.error?.message ?? "Could not create recipe"
    );
  } catch {
    return new FMSError("Something went wrong");
  }
};

export const updateCateringRecipe = async (
  recipeId: string,
  recipe: ICateringRecipe
): Promise<FMSError | null> => {
  try {
    const response = await post<void>(`${BASE}/${recipeId}`, recipe);
    if (Math.floor(response.status / 100) === 2) {
      return null;
    }
    return new FMSError(
      response.serverError?.error?.message ?? "Could not update recipe"
    );
  } catch {
    return new FMSError("Something went wrong");
  }
};

export const deleteCateringRecipe = async (
  recipeId: string
): Promise<FMSError | null> => {
  try {
    const response = await deletee<void>(`${BASE}/${recipeId}`);
    if (Math.floor(response.status / 100) === 2) {
      return null;
    }
    return new FMSError(
      response.serverError?.error?.message ?? "Could not delete recipe"
    );
  } catch {
    return new FMSError("Something went wrong");
  }
};

export const bulkUploadCateringRecipes = async (
  branchId: string,
  files: File[]
): Promise<FMSError | null> => {
  try {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("uploadedFile", files[i]);
    }
    const response = await post<void>(
      `${BASE}/by-branch/${branchId}/bulk`,
      formData,
      {
        method: "post",
        body: formData,
      },
      true,
      false
    );
    if (Math.floor(response.status / 100) === 2) {
      return null;
    }
    return new FMSError(
      response.serverError?.error?.message ?? "Upload failed"
    );
  } catch {
    return new FMSError("Something went wrong");
  }
};
